import { useState, useEffect } from 'react';
import examApis from '../../../apis/exams';
import { SnackbarSeverityType } from '../../../enums';
import { ScoringType } from '../../Exams/types';

const useScoringTypes = (
  open: boolean,
  school: string | undefined,
  showToast: (message: string, severity: SnackbarSeverityType) => void
): { scoringTypes: ScoringType[]; isLoading: boolean } => {
  const [scoringTypes, setScoringTypes] = useState<ScoringType[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!open || !school) return;
    setIsLoading(true);
    examApis
      .getScoringTypes(school)
      .then((response: any) => {
        setScoringTypes(response as ScoringType[]);
      })
      .catch(() => {
        showToast('Failed to load scoring types.', SnackbarSeverityType.error);
      })
      .finally(() => setIsLoading(false));
  }, [open, school, showToast]);

  return { scoringTypes, isLoading };
};

export default useScoringTypes;
